/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import { Alert, AlertTitle } from '@material-ui/lab';

// Styles
import useStyles from './modalBulkErrors.styles';

interface StateProps {
  success?: number;
  errors: Array<{
    primaryText: string;
    secondaryText?: string;
  }>;
}

type Props = StateProps;

const ModalBulkErrors: React.FC<Props> = ({ errors, success }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant='h4'>Erros de Submissão</Typography>
      <p className={classes.subtitle}>
        <span>{`${errors.length} Erro(s) encontrado(s)`}</span>
        {success && (
          <span>{`| ${success} Registro(s) afetado(s) com sucesso`}</span>
        )}
      </p>
      <List className={classes.list}>
        {errors.length > 0 &&
          errors.map((error, index) => (
            <ListItem key={index}>
              <Alert severity='error' className={classes.alert}>
                <AlertTitle>{error.primaryText}</AlertTitle>
                {error.secondaryText}
              </Alert>
            </ListItem>
          ))}
      </List>
    </div>
  );
};

export { ModalBulkErrors };
export default ModalBulkErrors;
